
export const submissionStateConstants = {
  notStarted: 'Not Started',
  inProgress: 'In Progress',
  submitted: 'Submitted',
  processed: 'Processed'
};
